import { createRoot } from 'react-dom/client';
import { lazy, Suspense } from 'react';
import './styles.css';
import './AnimatedNumber.css';
import './arena/ExploreScreen.css';
import './arena/CoinModal.css';
import './arena/CoinChart.css';
import './arena/BetBursts.css';
declare const __TEAM_PREVIEW__: boolean;
declare const __GAME_PREVIEW__: boolean;
const App = lazy(() =>
  __GAME_PREVIEW__
    ? import('./game-preview/GamePreview')
    : __TEAM_PREVIEW__
      ? import('./demo/TeamPreviewArena')
      : new URLSearchParams(location.search).get('demo') === '1'
        ? import('./reflex/ReflexApp')
        : import('./App'),
);
createRoot(document.getElementById('root')!).render(
  <Suspense fallback={<div role="status">Loading Run or Die…</div>}>
    <App />
  </Suspense>,
);
